<template>    
    <div class="container">
        <div class="card mt-3" style="align-items: center;">
            <div class="card-header" style="width: 100%;">
              <b-row align-h="between" align-v="center">
                <h4 class="mb-0">Gastos Reembolsables</h4>
                <b-button variant="dark" @click="back()">Volver </b-button>
              </b-row>
            </div>
            <template>
                <template>
                    <div class="card-body bordered">
                        <table class="table table-striped">
                            <tbody>                            
                                <tr>
                                    <th class="desc">Nº Orden</th>
                                    <td class="contenido">{{data.ordReemOtNro}}</td>
                                </tr>
                                <tr>
                                    <th class="desc">Tipo Servicio</th>
                                    <td class="contenido">{{data.ordReemTipOt}}</td>
                                </tr>
                                <tr>
                                    <th class="desc">Valor Servicio</th>
                                    <td class="contenido">{{data.ordReemMonto}}</td>
                                </tr>
                                <tr>
                                    <th class="desc">Ciudad</th>
                                    <td class="contenido">{{data.DescripcionCC}}</td>
                                </tr>
                                <tr>
                                    <th class="desc">Patente</th>
                                    <td class="contenido">{{data.ordReemPatente}}</td>
                                </tr>
                                <tr>
                                    <th class="desc">Observaciones</th>
                                    <td class="contenido">{{data.observacion}}</td>
                                </tr>
                                <tr>
                                    <th class="desc">Autorizado Por</th>
                                    <td class="contenido">{{data.autorizadoPor}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </template>
            </template>            
        </div>
    </div>
</template>
<script>
import moment from "moment";

export default {
    data() {
        return {
            data: this.$store.getters["hideValue/gastos"].item,
            fields:[
            {
                key: "ordReemOtNro",
                label: "Nº Orden",
                sortable: false,
                isRowHeader: true
            },
            {
                key: "ordReemTipOt",
                label: "Tipo Permiso",
                sortable: false,
            },
            {
                key: "ordReemMonto",
                label: "Valor Servicio",
                sortable: false,
            },
            {
                key: "DescripcionCC",
                label: "Ciudad",
                sortable: false,
            },
            {
                key: "ordReemPatente",
                label: "Patente",
                sortable: false,
            },
            {
                key: "observacion",
                label: "Observaciones",
                sortable: false,
            },
            {
                key: "autorizado",
                label: "Autorizado por",
                sortable: false,
            }
            ]
        };
    },
    methods: {
      back(){
        history.back();
      },
      formatFecha(fecha){
          return moment(fecha).format("DD-MM-YYYY") + " " + moment(fecha).format("HH:mm:ss")
      }
    },
};
</script>

<style scoped>
.card-header:first-child{
    border-radius: 0.25rem;
}
.desc{
    width: 200px;
    text-align: left;
}
.bordered{
    border: solid 1px rgb(238, 111, 111);
    border-radius: 1rem;
    width: 70%;
    margin-top: 1rem;
    margin-bottom: 1rem;
}
</style>
